import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { IReferralList } from '../../interface/IReferreal'

import {
  NoRegisterMessage,
  NoRegisterWrapper,
} from './components/TableBody/style'
import { TableBody } from './components/TableBody/TableBody'
import { TableHead } from './components/TableHead/TableHead'
import { IProps } from './interface/IProps'
import { StyledTable } from './style'

export const Table = ({ referral }: IProps) => {
  const { t } = useTranslation()
  const [tableData, setTableData] = useState<IReferralList[]>([])

  useEffect(() => {
    if (referral) {
      setTableData(referral)
    }
  }, [referral])

  return (
    <>
      <StyledTable>
        <TableHead />
        <TableBody tableData={tableData} />
      </StyledTable>
      {tableData.length === 0 && (
        <NoRegisterWrapper>
          <NoRegisterMessage>
            {t('Unfortunately there are no colleagues registered yet')}.
          </NoRegisterMessage>
        </NoRegisterWrapper>
      )}
    </>
  )
}
